import { Component } from 'preact';
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';

// Utils
import {
  validation,
  setFormValues,
  isInitialValid,
} from '../../utilities/form/formUtils';

// Actions
import { userDataFormSubmitAction } from '../../actions/UserData';
import { nextStepAction } from '../../actions/Section';

class Form extends Component {
  render() {
    const {
      app,
      children,
      className,
      actions,
      userData,
      initialValues,
    } = this.props;
    return (
      <Formik
        id={'form'}
        initialValues={{ ...userData }}
        isInitialValid={() => isInitialValid(userData, children)}
        validate={values => {
          if (app.debugServices) {
            console.group('Form'); // eslint-disable-line
            console.log('Validation:', validation(values, children)); // eslint-disable-line
            console.log('Values:', values); // eslint-disable-line
            console.groupEnd(); // eslint-disable-line
          }
          return validation(values, children);
        }}
        onSubmit={(values, { setSubmitting, setErrors }) => { // eslint-disable-line
          actions.userDataFormSubmitAction(values);
          actions.nextStepAction();
        }}
        render={({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          isValid,
          setValues,
          setFieldValue,
        }) => {
          const setFormValuesFunction = (name, value, formValues, formValuesTemplate) => {
            setFormValues(name, value, formValues, formValuesTemplate, values, setFieldValue);
          };
          const onFormBlur = (event, formValues = [], formValuesTemplate = '') => {
            handleBlur(event);
            if (formValues) {
              const { target: { name, value } } = event;
              setFormValuesFunction(name, value, formValues, formValuesTemplate);
            }
          };
          const childrenWithProps = React.Children.map(children, child => {
            // Check if any children is required
            const anyRequiredChildren = () => {
              const requiredChildren = children.filter(validChild => {
                return validChild.required;
              });
              return requiredChildren.length > 0;
            };

            const childProps = {
              ...child,
              value: values[child.id],
              'isValid': anyRequiredChildren() || isValid,
              onChange: handleChange,
              onBlur: onFormBlur,
              handleSubmit,
              errors,
              touched,
              setValues,
              values,
              setFormValues: setFormValuesFunction,
              userData,
              initialValues,
              setFieldValue,
            };

            return (React.cloneElement(child, childProps));
          }, {});

          return (
            <form className={className} onSubmit={handleSubmit}>
              {childrenWithProps}
            </form>
          );
        }}
      />
    );
  }
}

export default compose(
  connect((state) => {
    const { app, userData } = state;
    return {
      app,
      userData,
    };
  }, (dispatch) => ({
    actions: bindActionCreators({
      userDataFormSubmitAction,
      nextStepAction,
    }, dispatch),
  }))
)(Form);


Form.defaultProps = {
  className: null,
};

Form.propTypes = {
  actions: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  userData: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  className: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
};
